export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8737.46e7999c.jpg";